export default {
    products_equivalent: [],
    products: [],
    params:{
        product_equivalent_id: null,
    },
    loading: {
        module:false,
    },
}



// WEBPACK FOOTER //
// ./src/modules/products_equivalent/state.js